module.exports = __webpack_public_path__ + "static/img/ls35.ba08324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls35.png
// module id = mCGz
// module chunks = 12